import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom"; //packages
import { useState, useCallback, useEffect } from 'react';

import { UserContext } from "./UserContext.js";
import { resolveApiBaseUrl } from "./services/apiBaseUrl.js";
import helpers from "./helpers.js";
import Nav from "./components/Nav.js";

import HomeScreen from "./HomeScreen.js";
import SubscriptionScreen from "./SubscriptionScreen.js";
import UpdateSubscriptionScreen from "./components/subscription/UpdateSubscriptionScreen.js";
import UpdateDeliveryDetailsScreen from "./components/subscription/UpdateDeliveryDetailsScreen.js";
import UpdateBillingDetailsScreen from "./components/subscription/UpdateBillingDetailsScreen.js";
import ReviewSubscriptionScreen from "./components/subscription/ReviewSubscriptionScreen.js";
import ConfirmationScreen from "./components/subscription/ConfirmationScreen.js";



import LoginScreen from "./LoginScreen.js";
import SignUpScreen from "./SignUpScreen.js";
import ForgotPasswordScreen from "./ForgotPasswordScreen.js";
import AnalyticsScreen from "./AnalyticsScreen.js";
import SettingsScreen from "./SettingsScreen.js";
import SupportScreen from "./SupportScreen.js";
import OrdersScreen from "./OrdersScreen.js";
import InvoicesScreen from "./InvoicesScreen.js";
import ZonesScreen from "./ZonesScreen.js";
import NewZoneScreen from "./components/zones/NewZoneScreen.js";
import NewPlanScreen from "./components/zones/NewPlanScreen.js";

import AdminFarmersScreen from "./admin/AdminFarmersScreen.js";
import HelpCenterScreen from "./admin/HelpCenterScreen.js";
import TimelineScreen from "./admin/TimelineScreen.js";
import InventoryScreen from "./admin/InventoryScreen.js";
import CharcodesScreen from "./admin/CharcodesScreen.js";
import CharcodeScreen from "./CharcodeScreen.js";
import FinaliseOrderScreen from "./FinaliseOrderScreen.js";
import ScanOrderScreen from "./ScanOrderScreen.js";
import EbcAnalysisInProgress from "./EbcAnalysisInProgress.js";
import ComponentShowcase from "./ComponentShowcase.js";
// import Sandbox from "./Sandbox.js";
import RouteErrorBoundary from "./components/ErrorBoundary.js";
import RequireAuth from "./components/RequireAuth.js";

import styles from './App.module.css'; //styles

//assets



                                                                    
        
                                                                    
                                                                    
                                                                    
//                          ██████████████████                         
//                     ████████            ████████                    
//                  ██████                      ██████                 
//                █████                            █████               
//              ████                                  ████             
//            ████                                      ████           
//         ██████                                        ████          
//         ██ █                            ██              ███         
//         ████                            ███              ███        
//        █ ████                           ███               ███       
//        ██ ██████                      █████               ███       
//       ███  ███████████████████       ██████                ███      
//       ███    ███████████████████████████████               ███      
//      ███        ██████████████████████████████              ███     
//      ███             █████████████████████████              ███     
//      ███             █████████████████████████              ███     
//      ███            █████████████████████████               ███     
//      ████           ███████████████████████                ████     
//       ███           ████████████▓████████                  ███      
//        ██          █████████▒▒██████████                   ██       
//        ███        ███████▓░█████████████                  ███       
//         ███       █████▓░███████████████                 ███        
//          ███      ████░░█████████████████               ███         
//           ███    ████░▒██████████████████████          ███          
//            ████  ███▓▒███████████████████████████████████           
//              ███████░██████████████████████████████████             
//                █████░████████████████████████████████               
//                  ███▒██████████████████████████████                 
//                    █▓████████████████████████████                   
//                         ████████████████████                        
//                                 ████    


                                
// ██████  ██       █████   ██████ ██   ██     ██████  ██    ██ ██      ██          
// ██   ██ ██      ██   ██ ██      ██  ██      ██   ██ ██    ██ ██      ██          
// ██████  ██      ███████ ██      █████       ██████  ██    ██ ██      ██          
// ██   ██ ██      ██   ██ ██      ██  ██      ██   ██ ██    ██ ██      ██          
// ██████  ███████ ██   ██  ██████ ██   ██     ██████   ██████  ███████ ███████     

//           ██████  ██  ██████   ██████ ██   ██  █████  ██████                               
//           ██   ██ ██ ██    ██ ██      ██   ██ ██   ██ ██   ██                              
//           ██████  ██ ██    ██ ██      ███████ ███████ ██████                               
//           ██   ██ ██ ██    ██ ██      ██   ██ ██   ██ ██   ██                              
//           ██████  ██  ██████   ██████ ██   ██ ██   ██ ██   ██                              

                            
                                                                    
                                                              
const App = () => {
  const [token] = useState(null);
  
  /* 
    FOR CONTEXT THAT OFTEN CHANGES -> pass providerValue to context instead of state
    const providerValue = useMemo(() => ({value, setValue}), [value, setValue]) 
    
  */

  const [user, setUser] = useState({});

  const navigate = useNavigate(); //use callback
  const location = useLocation(); // Get current route



  const setUserDetails = (user, responseData, stayLoggedIn ) => {
      user.token = responseData.token;
      user.details = {};
      user.details.id = responseData.user._id;
      user.details.email = responseData.user.email;
      user.details.businessName = responseData.user.business_name;
      user.details.firstName = responseData.user.first_name;
      user.details.lastName = responseData.user.last_name;
      user.details.country = responseData.user.country;
      user.details.language = responseData.user.language;
      user.details.phoneMobile = responseData.user.phone_mobile;
      user.authed = true;
      if(stayLoggedIn){
        console.log("TOKEN SET")
        localStorage.setItem("token", user.token);
      }else{
        console.log("STAY LOGGED OUT")
        localStorage.removeItem("token");
      }
  }

  const setAdminDetails = (user, responseData, stayLoggedIn ) => {
    user.token = responseData.token;
    user.details = {};
    user.details.id = responseData.user._id;
    user.details.email = responseData.user.email;
    user.details.firstName = responseData.user.first_name;
    user.details.lastName = responseData.user.last_name;
    user.details.privileges = responseData.user.privileges;
    user.details.language = responseData.user.language;
    user.authed = true;
    if(stayLoggedIn){
      console.log("TOKEN SET")
      localStorage.setItem("token", user.token);
    }else{
      console.log("STAY LOGGED OUT")
      localStorage.removeItem("token");
    }
}

  // useEffect(() => {
  //   const initUser = async () => {

  //     /* USER OBJECT
  //     user = {
  //       authed: bool,
  //       token: string or null,
  //       backEndURL: str,
  //       details: {
  //         id: string,
  //         emaiL: string,
  //         firstName: string,
  //         lastName: string,
  //         language: string,
  //         country: string
  //       }
  //     }
  //     */

  //     let user = {};
  //     user.backEndURL = process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : process.env.REACT_APP_API_BASE_URL;
  //     console.log("HERE")
  //     console.log(user.backEndURL)
  //     user.frontEndURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.REACT_APP_FRONT_END_URL;

  //     user.token = localStorage.getItem("token");

  //     if (user.token === null){
  //       console.log("NO TOKEN")
  //       user.authed = false;
  //     } else {
  //       // const user = await retrieveUserData(user.token);
  //       console.log(user);
  //       const request = {
  //         method: "post",
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //           Authorization: "Bearer " + user.token,
  //         }
  //       };
    
  //       let response = await fetch(user.backEndURL + "/refresh-session", request);
  //       let jsonResponse = await response.json();
  //       if (jsonResponse.success) {
  //         setUserDetails(user, jsonResponse.data, true);
  //         console.log("SSSSILENTLY COMPLETES ITS MISSION, LIKE A NINJA");
  //       } else {
  //         console.log("WOOOOO")
  //       }
  //       //get user info here
  //       console.log(user)
  //     }
  //   // if(user.authed !== null){
  //     console.log(user)
  //     setUser(user);
  //     if (window.location.pathname.includes("/forgot-password") || window.location.pathname.includes("/sign-up")){
  //       return;
  //     }else if(user.authed){
  //       //navigate("/subscription"); UNCOMMMENT!!!!!!!!!
  //     }else if (window.location.pathname.includes("/charcode")){
  //       // navigate("/login");
  //     }else{
  //       navigate("/login");
  //     }
  //     // };
  //   }
  //   initUser();

  //   },[])



  useEffect(() => {
    let isMounted = true; // track if the component is still mounted
  
    const initUser = async () => {
      let user = {};
      user.backEndURL = resolveApiBaseUrl();
      user.frontEndURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.REACT_APP_FRONT_END_URL;
      user.token = localStorage.getItem("token");
      
      if (user.token === null) {
        console.log("NO TOKEN");
        user.authed = false;
      } else {
        console.log(user);
        const request = {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
          }
        };
  
        try {
          console.log("TRYING TO REFRESH");
          let response = await fetch(user.backEndURL + "/refresh-session", request);
          
          let jsonResponse = await response.json();
  
          if (jsonResponse.success && isMounted) {
            setUserDetails(user, jsonResponse.data, true);
            console.log("SSSSILENTLY COMPLETES ITS MISSION, LIKE A NINJA");
          } else if (isMounted) {
            console.log("WOOOOO");
          }
        } catch (error) {
          if (isMounted) {
            console.error("Error during fetch:", error);
          }
        }
      }
  
      if (isMounted) {
        console.log(user);
        setUser(user);
        console.log(window.location.pathname)

        // The redirect that used to live here has moved to <RequireAuth/> in
        // the route tree. It never worked from this effect: the final branch's
        // condition re-tested /forgot-password, which the first branch had
        // already returned from, so navigate("/login") was unreachable from
        // ed7021f (12/09/2024) onwards. Redirecting from an effect also paints
        // the screen before it leaves it, which a wrapper does not.
      }
    };
  
    initUser();
  
    // return () => {
    //   isMounted = false; // cleanup when component unmounts
    // };
  }, []); // Empty dependency array, runs once on mount

  // user.backEndURL, navigate
  const [screenTransitioning, setScreenTransitioning] = useState(false);

  // useEffect(() => {
  //   //defining the async function
   
  // }, [isAuthenticated])

  // // check if token valid before rehydrating, use lazy eval
  // if (localStorage.hasOwnProperty("user")) {
  //   console.log(localStorage.getItem("user").split("-")[2])
  //   console.log("Local storage found");
  //   this.state.authed = true;
  //   let user = {};
  //   user._id = localStorage.getItem("user").split("-")[0];
  //   user.name = localStorage.getItem("user").split("-")[1];
  //   user.token = localStorage.getItem("user").split("-")[2];
  //   this.state.user = user;
  // }


 




  // const goToScreen = useCallback((screenName, params) => {
  //   setScreenTransitioning(true);
  //   setTimeout(() => {
  //     setTimeout(() => {
  //       setScreenTransitioning(false);
  //       //return navigate(screenName)
  //     }, 100)
  //     console.log(params);
  //       return navigate(screenName, {state: params});
  //   }, 200)  
  // }, [navigate])
const goToScreen = useCallback((screenName, params) => {
  const freshParams = { ...params }; // force fresh closure

  setScreenTransitioning(true);
  setTimeout(() => {
    console.log("🔁 Navigating with:", freshParams);
    navigate(screenName, { state: freshParams });
    // Reset transition state after navigation completes
    setTimeout(() => {
      setScreenTransitioning(false);
    }, 30); // Reduced buffer time for route-level transitions
  }, 80); // Reduced from 100ms to 80ms for even snappier transitions
}, [navigate]);

  // Determine if current route is admin and get current screen name
  const isAdminRoute = location.pathname.startsWith('/admin');
  const currentScreen = location.pathname.substring(1); // Remove leading slash
  const showNav = !location.pathname.includes('/login') && 
                  !location.pathname.includes('/sign-up') && 
                  !location.pathname.includes('/forgot-password') &&
                  !location.pathname.includes('/dev/components') &&
                  !location.pathname.includes('/dev/layers') &&
                  !location.pathname.match(/^\/charcode\/[^\/]+$/) &&
                  !location.pathname.match(/^\/scan\/[^\/]+$/) &&
                  !location.pathname.match(/^\/order\/[^\/]+$/) &&
                  !location.pathname.includes('/ebc-analysis-in-progress');

  return (
    <div className={styles.BgContainer}>
      <div className={styles.BgHexOverlay}/>
      <div className={styles.MainContainer}>
        <UserContext.Provider value={{user, setUser}}>
          {showNav ? (
            <div className={helpers.clx("mainBlackContainer", "mainBlackContainerLoggedIn")}>
              <Nav 
                goToScreen={goToScreen} 
                isAdmin={isAdminRoute} 
                currentScreen={currentScreen}
              />
              <div className={helpers.clx("mainWhiteContainer", "mainWhiteContainerLoggedIn")}>
                <div className={helpers.clx(styles.RouteContainer, screenTransitioning ? styles.RouteContainerTransitioning : "")}>
                  <RouteErrorBoundary>
                  <Routes> 
                    <Route path="/" element={token !== null ? <Navigate to="/home" /> : <Navigate to="/login" />}/>
                    
                    {/* Auth Routes */}
                    <Route path="/login" element={<LoginScreen setUserDetails={setUserDetails} setAdminDetails={setAdminDetails}/>}/>
                    <Route path="/sign-up" element={<SignUpScreen/>}/>
                    <Route path="/forgot-password" element={<ForgotPasswordScreen/>}/>

                    {/* Everything below the guard needs a signed-in user. The
                        charcode, order, scan and EBC routes are deliberately
                        left outside it: they are public by design for QR
                        traceability and bbb-server's jwtExcludedRoutes agrees. */}
                    <Route element={<RequireAuth/>}>

                    {/* User Routes */}
                    <Route path="/home" element={<HomeScreen goToScreen={goToScreen}/>} />
                    <Route path="/analytics" element={<AnalyticsScreen goToScreen={goToScreen}/>}/>
                    <Route path="/subscription" element={<SubscriptionScreen goToScreen={goToScreen}/>} />
                    <Route path="/update-subscription" element={<UpdateSubscriptionScreen goToScreen={goToScreen}/>} />
                    <Route path="/update-delivery-details" element={<UpdateDeliveryDetailsScreen goToScreen={goToScreen}/>} />
                    <Route path="/update-billing-details" element={<UpdateBillingDetailsScreen goToScreen={goToScreen}/>} />
                    <Route path="/review-subscription" element={<ReviewSubscriptionScreen goToScreen={goToScreen}/>} />
                    <Route path="/confirm-subscription" element={<ConfirmationScreen goToScreen={goToScreen}/>} />
                    <Route path="/orders" element={<OrdersScreen goToScreen={goToScreen}/>} />
                    <Route path="/invoices" element={<InvoicesScreen goToScreen={goToScreen}/>} />
                    <Route path="/zones" element={<ZonesScreen goToScreen={goToScreen}/>}/>
                    <Route path="/new-zone" element={<NewZoneScreen goToScreen={goToScreen}/>}/>
                    <Route path="/new-plan" element={<NewPlanScreen goToScreen={goToScreen}/>}/>

                    <Route path="/settings" element={<SettingsScreen goToScreen={goToScreen}/>}/>
                    <Route path="/support" element={<SupportScreen goToScreen={goToScreen}/>}/>

                    {/* Admin Routes */}    
                    {/* <Route path="/admin/" element={<HomeScreen goToScreen={goToScreen}/>} /> */}
                    <Route path="/admin/farmers" element={<AdminFarmersScreen goToScreen={goToScreen}/>}/>
                    <Route path="/admin/help-center" element={<HelpCenterScreen goToScreen={goToScreen}/>}/>
                    <Route path="/admin/timeline" element={<TimelineScreen goToScreen={goToScreen}/>}/>
                    <Route path="/admin/charcodes" element={<CharcodesScreen goToScreen={goToScreen}/>}/>
                    <Route path="/admin/inventory" element={<InventoryScreen goToScreen={goToScreen}/>}/>

                    </Route>

                    {/* Charcode Routes */}
                    <Route path="/charcode/:charcodeId" element={<CharcodeScreen goToScreen={goToScreen} backEndURL={user.backEndURL}/>} />
                    <Route path="/order/:orderId" element={<FinaliseOrderScreen backEndURL={user.backEndURL}/>} />
                    <Route path="/scan/:orderId" element={<ScanOrderScreen backEndURL={user.backEndURL}/>} />
                    <Route path="/ebc-analysis-in-progress" element={<EbcAnalysisInProgress/>} />

                    {/* Dev/Showcase Routes */}
                    <Route path="/dev/components" element={<ComponentShowcase/>} />

                    {/* Sandbox Route */}
                    {/* <Route path="/sandbox" element={<Sandbox goToScreen={goToScreen}/>}/> */}

                  </Routes>
                  </RouteErrorBoundary>
                </div>
              </div>
            </div>
          ) : (
            <RouteErrorBoundary>
            <Routes> 
              <Route path="/" element={token !== null ? <Navigate to="/home" /> : <Navigate to="/login" />}/>
              
              {/* Auth Routes */}
              <Route path="/login" element={<LoginScreen setUserDetails={setUserDetails} setAdminDetails={setAdminDetails}/>}/>
              <Route path="/sign-up" element={<SignUpScreen/>}/>
              <Route path="/forgot-password" element={<ForgotPasswordScreen/>}/>

              {/* Charcode Routes */}
              <Route path="/charcode/:charcodeId" element={<CharcodeScreen goToScreen={goToScreen} backEndURL={user.backEndURL}/>} />
              <Route path="/order/:orderId" element={<FinaliseOrderScreen backEndURL={user.backEndURL}/>} />
              <Route path="/scan/:orderId" element={<ScanOrderScreen backEndURL={user.backEndURL}/>} />
              <Route path="/ebc-analysis-in-progress" element={<EbcAnalysisInProgress/>} />

              {/* Dev/Showcase Routes */}
              <Route path="/dev/components" element={<ComponentShowcase/>} />
            </Routes>
            </RouteErrorBoundary>
          )}
        </UserContext.Provider>
      </div>  
    </div>
    
  );
}

export default App;

